import React from "react";
import Button from "../../UI/Button";

export default function ComponentFormModal({
  editing,
  setEditing,
  onSave,
  onClose,
  saving,
}) {
  const handle = (field, value) =>
    setEditing((prev) => ({ ...prev, [field]: value }));

  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-start justify-center overflow-y-auto p-4">
      <div className="bg-white rounded-xl p-6 max-w-lg w-full my-8">
        <div className="flex items-start justify-between mb-4">
          <h3 className="text-xl font-bold">
            {editing.id ? "Редактировать составную часть" : "Новая составная часть"}
          </h3>
          <button
            type="button"
            className="text-gray-500 hover:text-black text-2xl"
            onClick={onClose}
          >
            ×
          </button>
        </div>

        <div className="space-y-3">
          <div>
            <label className="block text-sm font-medium mb-1">Название</label>
            <input
              value={editing.name}
              onChange={(e) => handle("name", e.target.value)}
              className="w-full p-2 border rounded"
              placeholder="Например: флакон / крышка / прокладка"
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">
              Кол-во в одном продукте
            </label>
            <input
              type="number"
              step="0.001"
              min="0"
              value={editing.quantity_in_product}
              onChange={(e) => handle("quantity_in_product", e.target.value)}
              className="w-full p-2 border rounded"
            />
            <p className="mt-1 text-xs text-gray-500">
              Обычно 1. Например, если нужно 2 крышки на 1 флакон — поставь 2.
            </p>
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">Комментарий</label>
            <textarea
              rows={2}
              value={editing.comment || ""}
              onChange={(e) => handle("comment", e.target.value)}
              className="w-full p-2 border rounded"
            />
          </div>
        </div>

        <div className="flex justify-end gap-2 mt-4">
          <Button variant="secondary" onClick={onClose} disabled={saving}>
            Отмена
          </Button>
          <Button variant="primary" onClick={onSave} disabled={saving}>
            {saving ? "Сохранение..." : "Сохранить"}
          </Button>
        </div>
      </div>
    </div>
  );
}